<template>
    <div class="onboarding-counter">
        Question {{ step }} of {{ totalSteps }}
    </div>
</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
        totalSteps: {
            type: Number,
            default: 0,
        },
    },
};
</script>
